module.exports = __webpack_public_path__ + "assets/img/shuiyin-yidengji.f71fbddc.png";